<template>
    <router-view></router-view>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// empty.vue?b581b56a